<template>
  <div class="container">
    <h3>Salasanan palautus:</h3>
    <form v-if="!done" @submit.prevent="onSubmit()">
      <fieldset>
        <label for="forgot-email">Sähköposti:</label>
        <input v-model="email" type="email" name="email" id="forgot-email" autocomplete="email">
        <button v-if="!loading" type="submit">Lähetä</button>
        <span v-else type="submit">Ladataan...</span>
      </fieldset>
      <span v-if="error" class="error">Lähetys epäonnistui.</span>
    </form>
    <div v-else>Salasanan palautusviesti on lähetetty. Tarkista sähköpostisi.</div>
  </div>
</template>

<script>

import types from './../store/types'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ForgotPasswordView',
  data () {
    return {
      email: this.$route.query.email || '',
      error: false,
      loading: false,
      done: false,
    }
  },
  computed: {
    ...mapGetters('Auth', ['loggedIn']),
  },
  methods: {
    onSubmit () {
      this.error = false;
      this.loading = true;
      const {email} = this;
      this.forgotPassword({email}).then(() => {
        this.loading = false;
        this.done = true;
      }).catch((err) => {
        this.loading = false;
        this.error = true;
      })
    },
    ...mapActions('Auth', ['forgotPassword']),
  },
}
</script>

<style lang="scss" scoped>
  @import 'src/color.scss';

  form {
    text-align: left;
    width: 80%;
    max-width: 400px;
    margin: 1em auto;
  }

  fieldset {
    border: none;
  }

  input, label {
    box-sizing: border-box;
    cursor: pointer;
  }

  input {
    display: block;
    width: 100%;
    margin-bottom: 1em;
    padding: 0.4em 0.3em;
    font-weight: bold;
  }

  label {
    width: 100%;
    display: inline-block;
    margin-bottom: 0.4em;
    font-weight: bold;
  }

  button {
    padding: 0.6em 0.8em;
    border-radius: 0.5em;
    background: linear-gradient($secondary-light, $secondary);
    color: white;
    display: block;
    margin: 0 auto;
    font-size: 110%;
    font-weight: bold;
  }

  button:hover,
  button:active,
  button:focus {
    background: white;
    border: 2px solid $secondary;
    color: initial;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/ForgotPasswordView.vue